/* src/app/bulk-contract-dialog/bulk-contract-dialog.component.scss */
.bulk-contract-modal {
  background: white;
  border-radius: 6px;
  width: 100%;
  max-width: 460px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
}
.bulk-contract-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 18px 24px 14px;
  border-bottom: 1px solid #e0e0e0;
}
.bulk-contract-title {
  font-size: 16px;
  font-weight: 500;
  color: #333;
}
.bulk-contract-subtitle {
  font-size: 13px;
  color: #666;
  margin-top: 4px;
}
.bulk-contract-close {
  background: none;
  border: none;
  font-size: 16px;
  cursor: pointer;
  color: #888;
  padding: 2px 4px;
}
.bulk-contract-close:hover {
  color: #333;
}
.bulk-contract-body {
  padding: 16px 24px;
}
.bulk-contract-section {
  margin-bottom: 16px;
}
.bulk-contract-label {
  font-size: 13px;
  color: #555;
  margin-bottom: 6px;
}
.bulk-contract-clients-preview {
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  padding: 10px 12px;
  max-height: 80px;
  overflow-y: auto;
  background: #fafafa;
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 16px;
}
.client-name-chip {
  display: inline-block;
  padding: 3px 10px;
  border-radius: 12px;
  font-size: 12px;
  background: white;
  border: 1px solid #e0e0e0;
  color: #333;
}
.bulk-contract-date {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #d0d0d0;
  border-radius: 4px;
  font-size: 13px;
  box-sizing: border-box;
}
.bulk-contract-date:focus {
  outline: none;
  border-color: #999;
}
.bulk-contract-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  padding: 12px 24px 20px;
  border-top: 1px solid #e0e0e0;
}
.bulk-footer-cancel {
  border: 1px solid #333;
  background: white;
  color: #333;
  padding: 6px 16px;
  border-radius: 4px;
  font-size: 13px;
  cursor: pointer;
}
.bulk-footer-cancel:hover {
  background: #f5f5f5;
}
.bulk-footer-apply {
  border: 1px solid #3f47cc;
  background: #3f47cc;
  color: white;
  padding: 6px 18px;
  border-radius: 4px;
  font-size: 13px;
  cursor: pointer;
}
.bulk-footer-apply:hover {
  background: #353db5;
}
.bulk-footer-apply:disabled {
  background: #bdbdbd;
  border-color: #bdbdbd;
  cursor: default;
}
/*# sourceMappingURL=bulk-contract-dialog.component.css.map */
